<script setup>
import CFIcon from '@/ui/Icon/CFIcon.vue';
</script>

<template>
    <div>
        <nav
            class="top-0 right-0 left-0 z-60 mb-8 flex flex-col items-center bg-black py-4 text-white md:fixed md:h-16 md:flex-row xl:h-16"
        >
            <div class="container flex flex-wrap items-center justify-between gap-y-4">
                <a href="https://platform.cyberfusion.io">
                    <img
                        src="/Cyberfusion_Logo_White.svg"
                        alt="Cyberfusion"
                        class="h-8 w-auto fill-white text-white"
                    />
                </a>

                <div class="flex flex-wrap items-center gap-x-12 gap-y-4 xl:justify-end">
                    <a
                        href="https://cyberfusion.io"
                        target="_blank"
                        class="group inline-flex items-center gap-2.5 text-lg"
                    >
                        {{ $t('general.website') }}
                        <div class="inline-flex size-6 items-center justify-center rounded-full bg-white">
                            <CFIcon
                                name="arrow-right"
                                class="size-3 -rotate-45 text-black transition group-hover:rotate-0"
                            />
                        </div>
                    </a>

                    <a
                        href="https://platform.cyberfusion.io"
                        target="_blank"
                        class="group inline-flex items-center gap-2.5 text-lg"
                    >
                        {{ $t('general.platform') }}
                        <div class="inline-flex size-6 items-center justify-center rounded-full bg-white">
                            <CFIcon
                                name="arrow-right"
                                class="size-3 -rotate-45 text-black transition group-hover:rotate-0"
                            />
                        </div>
                    </a>
                </div>
            </div>
        </nav>

        <div class="container pb-12 md:pt-24">
            <slot />
        </div>
    </div>
</template>
